<template>
  <div class="third LoginInAdvanceBottomInformation">
    <div class="third-formOne adhibition">
      <div class="formOne-btn">
        <div class="btn-left">
          <!-- <span class="left-back-icon" @click="goBack">
            <i class="el-icon-arrow-left"></i>
            <span class="left-back-title">返回</span>
          </span>
          <span class="left-back-shu">
            <span class="left-back-shu-content"></span>
          </span>-->
          <span class="left-back-content">预登陆底部展示信息配置</span>
          <!-- <span v-if="IDlist !== ''" class="left-back-content">编辑班级信息</span> -->
        </div>
        <div class="btn-right">
          <el-button @click="Reset()" class="btn-two" type="default"
            >重置</el-button
          >
          <el-button
            class="btn-two"
            type="primary"
            v-el-disabel-repeat-click
            @click="submitFN()"
            >保存</el-button
          >
        </div>
      </div>
      <el-form
        ref="formList"
        :model="formList"
        :rules="rules"
        :show-message="false"
        label-width="100px"
        @validate="validateValue"
      >
        <div class="formOne-forms">
          <div class="forms-one" style="margin-top: 57px">
            <div class="one-title">
              <div class="title-left">
                <span class="left-icon">
                  <i class="el-icon-s-operation"></i>
                </span>
                <span class="left-content palTel">联系方式</span>
              </div>
            </div>
            <div class="one-list myform">
              <el-form-item label="联系方式栏目名称" prop="contactName">
                <el-input
                  class="list-input myInput_config"
                  :maxlength="30"
                  v-model.trim="formList.contactName"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
              <el-form-item label="邮编">
                <el-input
                  class="list-input myInput_config"
                  :maxlength="30"
                  v-model.trim="formList.postalCode"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
              <el-form-item label="邮箱" prop="mailbox">
                <el-input
                  class="list-input myInput_config"
                  :maxlength="30"
                  v-model.trim="formList.mailbox"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
              <el-form-item label="电话" prop="phone">
                <el-input
                  class="list-input myInput_config"
                  :maxlength="30"
                  v-model.trim="formList.phone"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
              <el-form-item label="地址" prop="address">
                <el-input
                  class="list-input myInput_config"
                  :maxlength="60"
                  v-model.trim="formList.address"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
              <!-- :data="{fileType:1}"
                    :limit="1"
                    :on-preview="handlePictureCardPreview_S"
                    :on-remove="handleRemove_S"
                    :on-success="handleSuccess_S"
                    :on-error="hadleError_S"
                    :before-upload="beforeUpload_S"
              :file-list="fileList_S"-->
              <!-- :class="{hide:hideUpload_S}" -->
            </div>
          </div>
          <div class="forms-one">
            <div class="one-title">
              <div class="title-left">
                <span class="left-icon">
                  <i class="el-icon-s-operation"></i>
                </span>
                <span class="left-content palTel">网站应用信息</span>
              </div>
            </div>
            <div class="one-list myform">
              <!-- :data="{fileType:1}"
                    :limit="1"
                    :on-preview="handlePictureCardPreview_S"
                    :on-remove="handleRemove_S"
                    :on-success="handleSuccess_S"
                    :on-error="hadleError_S"
                    :before-upload="beforeUpload_S"
              :file-list="fileList_S"-->
              <!-- :class="{hide:hideUpload_S}" -->
              <el-form-item label="版权信息" prop="copyrightInformation">
                <el-input
                  class="list-input myInput_config"
                  :maxlength="30"
                  v-model.trim="formList.copyrightInformation"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
              <el-form-item label="备案号" prop="record">
                <el-input
                  class="list-input myInput_config"
                  :maxlength="30"
                  v-model.trim="formList.record"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
              <el-form-item label="备案号标志">
                <el-upload
                  class="list-upload-img my-upload"
                  action="/api/blade-platform/platformapplyguiselogo/upload"
                  accept=".jpg, .jpeg, .png, .gif"
                  list-type="picture-card"
                  :file-list="adLandingBackImgList"
                  :on-success="getAdLandingBackImg"
                  :on-remove="removeAdLandingBackImg"
                  :on-error="hadleError"
                  :before-upload="beforeUpload"
                  :limit="1"
                  :on-exceed="handleExceed"
                  :on-preview="handlePreview"
                >
                  <i class="el-icon-plus"></i>
                  <div class="list-upload-title" style="font-size: 12px">
                    点击上传
                  </div>
                  <!-- <div
                    slot="tip"
                    class="list-upload-tip my-upload-footer"
                    style="font-size: 10px"
                  >
                    5M以内，支持扩展名.png、.jpg、.jpeg、.gif，建议为1920*1080px的矩形图片
                  </div> -->
                </el-upload>
              </el-form-item>
              <el-form-item label="技术支持">
                <el-input
                  class="list-input myInput_config"
                  :maxlength="30"
                  v-model.trim="formList.technologySupport"
                  placeholder="请输入"
                ></el-input>
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="技术支持中可以使用占位符 ${nowYear} 展示当前年份，例如 @2020-${nowYear} > @2020-2022"
                  placement="top-start"
                >
                  <div style="display: inline-block;">
                    <tail-describe></tail-describe>
                  </div>
                </el-tooltip>
              </el-form-item>
            </div>
          </div>
          <div class="forms-one">
            <div class="one-title">
              <div class="title-left">
                <span class="left-icon">
                  <i class="el-icon-s-operation"></i>
                </span>
                <span class="left-content palTel">常用链接</span>
              </div>
            </div>
            <div class="one-list myform">
              <el-form-item label="常用链接展示名称" prop="commonLinks">
                <el-input
                  class="list-input myInput_config"
                  :maxlength="30"
                  v-model.trim="formList.commonLinks"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
              <div class="add-row-LoginInAdvanceBottomInformation">
                <el-button
                  :disabled="this.formList.linksList.length >= 8"
                  icon="el-icon-plus"
                  @click="updateConfirm(null)"
                  >添加</el-button
                ><span
                  style="font-size: 12px; margin-left: 10px; color: #2e4057"
                  >最多可配置8个</span
                >
                <!-- <span
                  >此处的栏目请提前进行用户信息的对接，<span
                    class="list-view-oneline"
                    style="color: #409eff; cursor: pointer"
                    @click="openUrl('https://www.baidu.com')"
                    >点击获取对接方式</span
                  >
                </span> -->
              </div>
              <div class="list-four-line">
                <el-table
                  class="third-tableThree"
                  :data="formList.linksList"
                  border
                  stripe
                >
                  <el-table-column
                    prop="name"
                    label="名称"
                    :show-overflow-tooltip="true"
                  ></el-table-column>
                  <el-table-column
                    prop="url"
                    label="链接"
                    :show-overflow-tooltip="true"
                  ></el-table-column>
                  <el-table-column
                    prop="sort"
                    label="顺序"
                    :show-overflow-tooltip="true"
                  ></el-table-column>
                  <el-table-column
                    prop="state"
                    label="操作"
                    :show-overflow-tooltip="true"
                  >
                    <template slot-scope="scope">
                      <el-button
                        type="text"
                        size="small"
                        @click="updateConfirm(scope.row, scope.$index)"
                        :disabled="scope.row.editStatus === 'ALL'"
                        >编辑</el-button
                      >
                      <span class="tableThree-height-shu">
                        <span class="shu-item"></span>
                      </span>
                      <el-button
                        type="text"
                        size="small"
                        @click="deleteRowConfirm(scope.row, scope.$index)"
                        :disabled="scope.row.editStatus === 'ALL'"
                        >删除</el-button
                      >
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
        </div>
      </el-form>
    </div>
    <preview-modal
      :previewModal="dialogVisible"
      :previewImageUrl="dialogImageUrl"
      @previewClose="closePreview"
    ></preview-modal>
    <addAndColumn
      ref="LoginInAdvanceBottomInformation"
      :modalTitle="formList.modalTitle"
      :newModalVisible="newModalVisible"
      @closeNewTask="closeImport"
      @addNewTask="addNewTask"
      @updateClu="updateClu"
    >
    </addAndColumn>
    <notice-modal
      :noticeModalVisible="noticeModal"
      @noticeModalClose="closeNotice"
      @noticeModalAgree="agreeNotice"
      :noticeTitle="noticeTitle"
      :noticeSpec="noticeSpec"
      :noticeType="noticeType"
      :btnAgree="agreeContent"
      :noticeContent="noitceContent"
    >
    </notice-modal>
  </div>
</template>

<script>
import { detailWG, submit } from "@/store/management/Myconfig"; //我的
import addAndColumn from "./components/addAndColumn.vue";
import { setStore, getStore } from "@/utils/store";
import { cloneDeep } from "lodash";
export default {
  name: "formSeven",
  props: ["IDlist"],
  components: {
    addAndColumn,
  },
  data() {
    return {
      // color: '#FF4D4F',
      rules: {
        name: [{ required: true, message: "请输入系统名称", trigger: "blur" }],
        description: [
          { required: true, message: "请输入系统校训", trigger: "blur" },
        ],
        commonLinks: [
          {
            required: true,
            message: "请输入常用链接展示名称",
            trigger: "blur",
          },
        ],
        recordUrl: [{ required: true, message: "请选择预登陆背景图" }],
        // advanceLogo: [{ required: true, message: "请选择预登陆logo" }],
        // logo: [{ required: true, message: "请选择系统logo" }],
        advanceColor: [{ required: true, message: "请选择预登陆主题色" }],
        contactName: [
          {
            required: true,
            message: "请输入联系方式展示名称",
            trigger: "blur",
          },
        ],
        address: [{ required: true, message: "请输入地址", trigger: "blur" }],
        phone: [{ required: true, message: "请输入电话", trigger: "blur" }],
        mailbox: [{ required: true, message: "请输入邮箱", trigger: "blur" }],
        postalCode: [
          { required: true, message: "请输入邮编", trigger: "blur" },
        ],
        copyrightInformation: [
          { required: true, message: "请输入版权信息", trigger: "blur" },
        ],
        record: [{ required: true, message: "请输入备案号", trigger: "blur" }],
      },
      formList: {
        id: "",
        logo: "", //系统logo
        name: "", // 系统名称
        description: "", // 系统校训
        recordUrl: "", // 预登陆背景图
        advanceLogo: "", // 预登陆logo
        commonLinks: "", // 常用链接展示名称
        advanceColor: "", // 预登陆主题色
        webImConfig: 1, // web-im 启用配置
        //====================================新增参数
        contactName: "", //联系方式展示名称
        address: "",
        phone: "",
        mailbox: "",
        postalCode: "", //邮编
        copyrightInformation: "", //版权
        record: "", //备案号
        technologySupport: "", //技术支持
        //====================================新增编辑栏目
        linksList: [],
        updateTime: "",
        createTime: "",

        //   &********弹框******************************
      }, //数据
      modalTitle: "",
      newModalVisible: false,
      clickIndex: 0, //点击编辑行的index
      tableDataShow: [
        //列表表头
        {
          column: "名称",
          key: "name",
          needKeyValue: false,
          caseKey: "name",
        },
        {
          column: "链接",
          key: "url",
          needKeyValue: false,
          caseKey: "url",
        },
        {
          column: "顺序",
          key: "sort",
          needKeyValue: false,
          caseKey: "sort",
        },
      ],
      fileList: [], //默认配置图
      dialogVisible: false,
      dialogImageUrl: "",
      adLandingBackImgList: [],
      adLandingLogoList: [],
      sysLogo: [],
      countNum: 1,
      //   &********弹框******************************
      agreeNotice: {},
      noticeType: 1, // 提示类型
      agreeContent: "确定", // 提示弹窗确认按钮内容
      noticeTitle: "提示", // 提示
      noitceContent: "确定启用删除吗？", // 提示信息
      noticeModal: false, // 提示弹窗
      noticeSpec: "", // 标红提示
      //   &**************************************
    };
  },
  created() {
    this.detailWGFN();
    // this.GetCurrentTableData(); //获取与我相关的关联业务
  },
  methods: {
    // 关闭弹窗
    closeNotice() {
      this.noticeModal = false;
    },
    closeImport() {
      this.newModalVisible = false;
    },
    async addNewTask(obj) {
      console.log(obj);
      //   return
      //   try {
      //     let {
      //       data: { status, msg, result },
      //     } = await this.$store.dispatch("AlumniMomentTitleAdd", {
      //         url:obj.url
      //     });
      //     if (status === 1000) {
      const aaa = this.formList.linksList.find((item) => {
        return item.name == obj.name;
      });
      if (aaa) {
        this.$message.error("常用链接名称不可重复");
        return;
      }
      this.formList.linksList.unshift({
        name: obj.name,
        url: obj.url,
        sort: obj.sort,
        startTime: obj.startTime,
        updateTime: obj.updateTime,
      });
      this.newModalVisible = false;
      //     } else {
      //       this.$message({
      //         type: "error",
      //         message: msg,
      //       });
      //     }
      //   } catch (err) {
      //     console.log(err);
      //   }
    },
    async updateClu(obj) {
      console.log(obj);
      const arr = cloneDeep(this.formList.linksList);
      arr.splice(this.clickIndex, 1);
      const aaa = arr.find((item) => {
        return item.name == obj.name;
      });
      //   debugger
      if (aaa) {
        return this.$message.error("常用链接名称不可重复");
      }
      //   try {
      //     let {
      //       data: { status, msg, result },
      //     } = await this.$store.dispatch("AlumniMomentTitleUpdate", obj);
      //     this.newModalVisible = false;
      //     if (status === 1000) {
      this.formList.linksList.splice(this.clickIndex, 1);
      console.log(this.formList.linksList);
      //   debugger
      this.formList.linksList.unshift({
        name: obj.name,
        url: obj.url,
        sort: obj.sort,
        startTime: obj.startTime,
        updateTime: obj.updateTime,
      });
      console.log(this.formList.linksList);
      this.newModalVisible = false;
      //     } else {
      //       this.$message({
      //         type: "error",
      //         message: msg,
      //       });
      //     }
      //   } catch (err) {
      //     console.log(err);
      //   }
    },
    deleteRowConfirm(rowData, index) {
      this.noitceContent = "确定删除吗？";
      this.agreeNotice = () => {
        this.noticeModal = false;
        this.deleteRow(index);
      };
      this.noticeModal = true;
    },
    deleteRow(index) {
      this.formList.linksList.splice(index, 1);
    },
    // 获取详情
    async GetCurrentTableData() {
      const GetCurrentTableData = await this.$store.dispatch(
        "GetCurrentTableData",
        {}
      );
      if (GetCurrentTableData.data.status != 1000) {
        this.$message.error(GetCurrentTableData.data.msg);
        return;
      }
      //   this.formList.currentTableData = GetCurrentTableData.data.result;
      //   console.log(GetCurrentTableData, "详情");
    },
    //编辑d
    updateConfirm(rowData, index) {
      // debugger
      console.log(rowData, index);
      if (rowData) {
        this.modalTitle = "编辑";
        this.clickIndex = index;
      } else {
        this.modalTitle = "新增";
      }
      setStore({
        name: "LoginInAdvanceBottomInformation",
        content: rowData,
        type: "session",
      });
      this.newModalVisible = true;
      this.$refs["LoginInAdvanceBottomInformation"].Reset();
    },
    validateValue(prop, msgStatus, validateMessage) {
      if (!this.countNum && !msgStatus) {
        this.countNum += 1;
        if (validateMessage) {
          this.$message.error(validateMessage);
        }
      }
    },
    toPreview() {
      // this.$router.push({
      //   name: 'previewAdvanceLanding'
      // });
      const strData = JSON.stringify(this.formList);
      sessionStorage.setItem("formValue", strData);
      const url =
        window.location.protocol +
        "//" +
        window.location.host +
        window.location.pathname +
        "#/previewAdvanceLanding";
      window.open(url);
    },
    // 预登陆logo成功回调函数
    getAdLandingLogo(response) {
      console.log("data", response);
      this.formList.advanceLogo = response.result;
    },
    removeAdLandingLogo() {
      this.formList.advanceLogo = "";
      this.adLandingLogoList = [];
      // console.log(fileList)
    },
    removeSysLogo() {
      this.formList.logo = "";
      this.sysLogo = [];
      console.log(fileList);
    },
    // 系统logo成功回调函数
    getSysLogo(response) {
      this.formList.logo = response.result;
      console.log(fileList);
    },
    removeAdLandingBackImg() {
      this.formList.recordUrl = "";
      this.adLandingBackImgList = [];
    },
    // 预登陆背景成功回调函数
    getAdLandingBackImg(response) {
      console.log("result", response);
      this.formList.recordUrl = response.result;
    },
    handleExceed() {
      this.$message.error("一次只能上传一张图片");
    },
    //保存
    submitFN() {
      this.countNum = 0;
      this.$nextTick(() => {
        this.$refs.formList.validate((valid) => {
          if (valid) {
            try {
              if (this.formList.linksList.length < 1) {
                this.$message.error("请添加常用链接");
                return;
              }
              //   const params = this.formList;
              //   submit(params).then((res) => {
              //     const data = res.data;
              //     if (data.status === 1000) {
              //       this.$message.success("操作成功");
              //     } else {
              //       this.countNum = 1;
              //       this.$message.error(data.msg);
              //     }
              //   });
              return this.submit();
            } catch (err) {
              this.countNum = 1;
              console.log(err);
            }
          } else {
            return false;
          }
        });
      });
    },
    async submit() {
      try {
        const params = this.formList;
        let {
          data: { status, msg, result },
        } = await this.$store.dispatch(
          "platformPrepareLoginButtomConfigSubmit",
          params
        );
        if (status === 1000) {
          console.log(result);
          this.$message.success("保存成功");
        } else {
          this.$message({
            type: "error",
            message: msg,
          });
        }
      } catch (err) {
        console.log(err);
      }
    },
    //重置
    Reset() {
      this.fileList = [];
      this.adLandingBackImgList = [];
      this.sysLogo = [];
      this.adLandingLogoList = [];
      this.detailWGFN();
    },
    //获取数据
    async detailWGFN() {
      try {
        let {
          data: { status, msg, result },
        } = await this.$store.dispatch(
          "platformPrepareLoginButtomConfigDetail",
          {}
        );
        if (status === 1000) {
          console.log(result);
          //   cloneDeep(result);
          (this.formList = {
            id: result.id ? result.id : "",
            logo: "", //系统logo
            name: "", // 系统名称
            description: "", // 系统校训
            recordUrl: result.recordUrl ? result.recordUrl : "", // 预登陆背景图
            advanceLogo: "", // 预登陆logo
            commonLinks: result.commonLinks ? result.commonLinks : "", // 常用链接展示名称
            advanceColor: "", // 预登陆主题色
            webImConfig: 1, // web-im 启用配置
            //====================================新增参数
            contactName: result.contactName ? result.contactName : "", //联系方式展示名称
            address: result.address ? result.address : "",
            phone: result.phone ? result.phone : "",
            mailbox: result.mailbox ? result.mailbox : "",
            postalCode: result.postalCode ? result.postalCode : "", //邮编
            copyrightInformation: result.copyrightInformation
              ? result.copyrightInformation
              : "", //版权
            record: result.record ? result.record : "", //备案号
            technologySupport: result.technologySupport
              ? result.technologySupport
              : "", //技术支持
            //====================================新增编辑栏目
            linksList: result.linksList ? result.linksList : "",
            updateTime: result.updateTime ? result.updateTime : "",
            createTime: result.createTime ? result.createTime : "",

            //   &********弹框******************************
          }), //数据
            //   this.formList = cloneDeep(result);
            //   console.log(new Date.getTime());
            // this.adLandingBackImgList.push({
            //   name: new Date().getTime(),
            //   url: result.recordUrl ? result.recordUrl : "",
            // });
            console.log(result.recordUrl);
            if (result.recordUrl) {
                this.adLandingBackImgList.push({
                name: new Date().getTime(),
                url: result.recordUrl
                });
            }
        } else {
          this.$message({
            type: "error",
            message: msg,
          });
        }
      } catch (err) {
        console.log(err);
      }
    },
    //上传之前
    beforeUpload(file) {
      const isJPG = ["image/png", "image/jpg", "image/jpeg"].indexOf(file.type);

      if (isJPG == -1) {
        this.$message.error("上传头像只能是png jpg jpeg图片格式!");
        return false;
      }

      const imgsize = file.size / 1024 / 1024 <= 5;
      if (!imgsize) {
        this.$message.error("上传图片最大5M, 请重新上传!");
        return false;
      }
    },
    //成功
    handleSuccess(file) {
      // console.log(file)
      this.formList.logo = file.result;
    },
    //点击
    handlePreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    //失败
    hadleError(err) {
      this.$message.error(err);
    },
    //移除
    handleRemove(file, fileList) {
      this.formList.logo = "";
      console.log("移除");
    },
    //关闭弹框
    closePreview() {
      this.dialogVisible = false;
    },
  },
};
</script>

<style lang="scss">
.LoginInAdvanceBottomInformation {
  .add-row-LoginInAdvanceBottomInformation {
    .el-button {
      margin-left: 0px !important;
      margin-bottom: 5px;
    }
    .third .el-button {
      margin-left: 0px !important;
    }
  }
  .phon-right {
    position: relative;
    // border:1px solid red;
    width: 40%;
    display: inline-block;
    // height:calc(100vh - 102px);
    height: 100%;
    border-left: 1px solid #dcdee2;
    img {
      // border: 1px solid red;
      width: 389px;
      height: 669px;
      position: absolute;
      left: 0;
      right: 0;
      margin: auto;
    }
  }
  .third-tableThree {
    max-width: 1400px;
    .el-button {
      margin-left: 0 !important;
    }
  }
  .tableThree-height-shu {
    display: inline-block;
    padding: 0 4px;
    position: relative;
    .shu-item {
      position: absolute;
      width: 1px;
      height: 12px;
      background-color: #d4d4d7;
      display: inline-block;
      top: -10px;
    }
  }
  .myform {
    .el-form-item__label {
      padding-right: 10px;
    }
  }
  .myInput_config {
    width: 298px !important;
  }
  .palTel {
    font-size: 14px !important;
  }
  .my-upload {
    // height: 115px;
    height: 80px;
    position: relative;
    .el-upload--picture-card {
      width: 80px !important;
      height: 80px !important;
      line-height: 80px !important;
      float: left;
      overflow: hidden;
    }
    .el-upload-list__item {
    //   width: 204px !important;
    //   height: 80px !important;
      max-width: 82px !important;
      max-height: 80px !important;
      margin-left: 14px !important;
    }
    .my-upload-footer {
      position: absolute;
      left: 0;
      bottom: 0;
    }
  }
}
</style>
